module.exports = __webpack_public_path__ + "img/277.fd982c58.png";